import { Navigate } from "react-router-dom";
import RoleGuard from "../guard/roleGuard";
import Dcs0101 from "../pages/dcs/dcs0101/Dcs0101";
import Dcs0201 from "../pages/dcs/dcs0201/Dcs0201";
import Dcs0301 from "../pages/dcs/dcs0301/Dcs0301";
import Dcs0201View from "../pages/dcs/dcs0201/Dcs0201View";

export const dcsRouter: any = [
  {
    path: "dcs/dcs0101",
    element: (
      <RoleGuard>
        <Dcs0101 />
      </RoleGuard>
    ),
  },
  {
    path: "dcs/dcs0201",
    element: (
      <RoleGuard>
        <Dcs0201View />
      </RoleGuard>
    ),
  },
  {
    path: "dcs/dcs0301",
    element: (
      <RoleGuard>
        <Dcs0301 />
      </RoleGuard>
    ),
  },
];
